import { IconSvgProps } from '../types';

export const PaperPlane = ({ size }: IconSvgProps) => (
  <svg
    id="icon-object-paper plane"
    width={size}
    height={size}
    viewBox="0 0 60 65"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <g transform="translate(17.000000, 53.000000)" fillRule="nonzero">
          <g transform="translate(13.000000, 0.000000)" opacity="0.5">
            <g>
              <path d="M0.14,11.3 C2.43,11.4 4.76,10.4 6.33,8.4 L12.73,0.3 L0.14,0.3 L0.14,11.3 Z" />
            </g>
          </g>
          <g>
            <path d="M13.14,11.3 C10.85,11.4 8.52,10.4 6.95,8.4 L0.56,0.3 L13.14,0.3 L13.14,11.3 Z" />
          </g>
        </g>
        <path
          d="M28.53,1.2 C28.53,1.2 28.53,1.2 28.53,1.2 L1.33,47.7 C1.32,47.7 1.31,47.7 1.3,47.7 C0.99,48.3 0.82,48.9 0.82,49.5 C0.82,50 0.91,50.5 1.08,50.9 C1.17,51.2 1.3,51.4 1.44,51.6 C2.11,52.6 3.26,53.3 4.56,53.3 L30.14,53.3 L30.14,0.3 C29.52,0.3 28.9,0.6 28.53,1.2 Z"
          fillRule="nonzero"
          opacity="0.5"
        />
        <g transform="translate(30.000000, 0.000000)">
          <path d="M29.01,47.8 C28.99,47.7 28.97,47.7 28.95,47.7 L1.74,1.2 C1.38,0.6 0.76,0.3 0.14,0.3 L0.14,53.3 L25.72,53.3 C27.01,53.3 28.15,52.6 28.82,51.6 C28.98,51.4 29.11,51.1 29.22,50.9 C29.38,50.5 29.46,50 29.46,49.5 C29.46,48.9 29.31,48.3 29.01,47.8 Z" />
        </g>
      </g>
    </g>
  </svg>
);
